import Vue from 'vue'
import { AuthState, User } from './types'

const getDefaultState = () => {
    const state: AuthState = {
        user: undefined,
        entityId: 0
    }
    return state;
}

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        SET_USER(state: AuthState, user: User) {
            state.user = user
        },
        SET_ENTITY(state: AuthState, entityId: number) {
            state.entityId = entityId
        },
        LOG_OUT(state: AuthState) {
            state.user = undefined;
        },
        RESET_STATE(state: AuthState) {
            Object.assign(state, getDefaultState())
        }
    },
    actions: {
        async login({ rootState, commit, dispatch }, { username, password }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('username', username);
            params.append('password', password);
            // SET AUTH OPTIONS
            const options = [
                "WMPC_USER_SETTINGS"
            ];
            params.append('options', JSON.stringify(options))
            //
            try {
                const response = await Vue.axios.post('auth', params);
                const user: User = response.data;
                Vue.axios.defaults.headers.common['Authorization'] = "Bearer " + user.token;
                sessionStorage.setItem('token', user.token);
                commit('SET_USER', user);
                if (rootState.notifs.provider.publicId) {
                    const { publicId } = rootState.notifs.provider;
                    const message = "LOGGED IN";
                    dispatch("notifs/ackProviderSMS", { publicId, message }, { root: true });
                }
                return user;
            } catch (err) {
                sessionStorage.removeItem('token');
                throw err;
            }
        },
        async logout({ commit }) {
            delete Vue.axios.defaults.headers.common['Authorization'];
            sessionStorage.removeItem('token');
            commit('LOG_OUT');
            commit('RESET_STATE');
            commit('gaps/RESET_STATE', null, { root: true });
            commit('patients/RESET_STATE', null, { root: true });
            commit('schedule/RESET_STATE', null, { root: true });
        }
    },
    getters: {
        loggedIn: (state: AuthState) => !!state.user,
        userMeasureTypes: (state: AuthState): Array<string> => {
            if (state.user) {
                return [
                    ...new Set(state.user.providers.map((p) => p.measureTypeId)),
                ];
            }
            return [];
        },
        userCalendars: (state: AuthState): Array<any> => {
            if (state.user) {
                return state.user.calendars;
            }
            return [];
        }
    }
}
